import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import { BookRequest, BookResponse } from "@builtbybros/al-model";

import { AuthService } from "../../auth/auth.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class BookService {
  bookUrl = "/Book";
  highlightBookUrl = "/BookHighlight";
  bookImportUrl = "/BookImport";
  bookImportStockUrl = "/BookImport/Stock";

  constructor(private http: Http, private authService: AuthService) {}

  getBook(id: number): Observable<BookResponse.Book> {
    const options = this.authService.addAuthToken();

    return this.http
      .get(environment.alApiUrl + this.bookUrl + "/" + id, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
    // TODO: Catch error.
  }

  // getAllBooks(pagination: number = 25, offset: number = 0, query: string = '', sort: string = ''): Observable<BookResponse.All> {
  getAllBooks(
    pagination?: number,
    offset?: number,
    query?: string,
    sort?: string,
    isbn?: number,
    min_price?: number,
    max_price?: number,
    tags?: string,
    actives?: boolean
  ): Observable<any> {
    const options = this.authService.addAuthToken();
    const paginationStr = pagination ? `pagination=${pagination}` : "";
    const offsetStr = offset ? `&offset=${offset}` : "";
    const queryStr = query ? `&query=${query}` : ``;
    const sortStr = sort ? `&sort=${sort}` : ``;
    const isbnStr = isbn ? `&isbn=${isbn}` : ``;
    const min_priceStr = min_price ? `&min_price=${min_price}` : ``;
    const max_priceStr = max_price ? `&max_price=${max_price}` : ``;
    const tagsStr = tags ? `&tags=${tags}` : ``;
    const activesStr = actives !== null ? `&actives=${actives}` : ``;
    const path = `${environment.alApiUrl}${this.bookUrl}/All?${paginationStr}${offsetStr}${queryStr}${sortStr}${isbnStr}${min_priceStr}${max_priceStr}${tagsStr}${activesStr}`;
    console.error({path})
    console.error({options})
    return this.http.get(path, options).map((res: Response) => {
      const json = res.json();
      return json;
    });
  }

  getAlldisabledBooks(
    pagination?: number,
    offset?: number,
    query?: string
  ): Observable<BookResponse.All> {
    const options = this.authService.addAuthToken();
    const paginationStr = pagination ? `pagination=${pagination}` : "";
    const offsetStr = offset ? `&offset=${offset}` : "";
    const queryStr = query ? `&query=${query}` : ``;
    const path = `${environment.alApiUrl}${this.bookUrl}/Disables?${paginationStr}${offsetStr}${queryStr}`;
    return this.http.get(path, options).map((res: Response) => {
      const json = res.json();
      return json;
    });
  }

  updateBook(
    id: number,
    bookRequest: BookRequest.Update
  ): Observable<BookResponse.Book> {
    const options = this.authService.addAuthToken();

    return this.http
      .patch(
        `${environment.alApiUrl}${this.bookUrl}/${id}`,
        bookRequest,
        options
      )
      .map(res => {
        const json = res.json();
        const bookResponse = new BookResponse.Book();
        return bookResponse.parse(json["book"]);
      });
  }

  deleteBook(id: number): Observable<number> {
    const options = this.authService.addAuthToken();
    return this.http
      .delete(`${environment.alApiUrl}${this.bookUrl}/${id}`, options)
      .map(res => {
        return 1;
      });
  }

  highlightBook(ids: string): Observable<number> {
    const options = this.authService.addAuthToken();
    let highlightBook = new BookRequest.Highlight();
    highlightBook.ids = ids;

    return this.http
      .patch(
        `${environment.alApiUrl}${this.highlightBookUrl}/Assign`,
        highlightBook,
        options
      )
      .map(res => {
        return 1;
      });
  }

  unhighlightBook(ids: string): Observable<number> {
    const options = this.authService.addAuthToken();
    let highlightBook = new BookRequest.Highlight();
    highlightBook.ids = ids;

    return this.http
      .patch(
        `${environment.alApiUrl}${this.highlightBookUrl}/Remove`,
        highlightBook,
        options
      )
      .map(res => {
        return 1;
      });
  }

  importBook(timeStamp: number): Observable<number> {
    const options = this.authService.addAuthToken();
    const path = `${environment.alApiUrl}${this.bookImportUrl}?timestamp=${timeStamp}`;
    this.importBookStock(timeStamp).subscribe();
    return this.http.post(path, null, options).map(res => {
      return 1;
    });
  }
  importBookStock(timeStamp: number): Observable<number> {
    const options = this.authService.addAuthToken();
    const path = `${environment.alApiUrl}${this.bookImportStockUrl}?timestamp=${timeStamp}`;
    return this.http.post(path, null, options).map(res => {
      return 1;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/book/shared/book.service.ts